export default __webpack_public_path__ + "static/media/dolcemare8.fd9ecd02.jpg";